<template>
  <b-container fluid>
    <loading :active.sync="isGenerando" :is-full-page="true"></loading>
  
    <b-row align-h="center"  >
      <b-col cols="12" md="10" lg="7">
        <b-row no-gutters > 
          <b-col >
            <b-img :src="require('@/assets/parquimetro.png')"  fluid-grow alt="Fluid-grow image"></b-img>
          </b-col>
        </b-row>


        
        <!----------------------------------------------------Collapse ------------------------------------------------------>
        <b-row  no-gutters style="margin:15px;" class="mt-5">
          <b-col>
            <b-row v-if="estado==null">
              <b-col  class="card-form-primary " >
                <b-row class="mt-3">
                  <b-col cols="12" lg="12">  
                    <b-alert variant="danger" dismissible @dismissed="cleanMsgError" :show="msgErrorContribuyente != ''">
                        {{msgErrorContribuyente}}
                    </b-alert>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="6" lg="6">
                    <h6><b-icon icon="house-door"/> Placa Vehicular</h6>
                    <b-form-group >
                      <b-form-input :state="!$v.placa.$invalid" type="text" v-model.trim="placa"></b-form-input>
                      <div class="error" v-if="!$v.placa.minLength">La placa es incorrecta.</div>
                      <div class="error" v-if="!$v.placa.maxLength">La placa es incorrecta.</div>
                      <div class="error" v-if="!$v.placa.required">Ingrese su placa.</div>            
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row >
                  <b-col cols="12" lg="3">
                    <vue-recaptcha ref="recaptchaPredial" sitekey="6LdD09sUAAAAANCvTN2xMZqvfMOvzkdkOB1Zcpok" @verify="captchaPredialFilled" @expired="captchaPredialExpired" :loadRecaptchaScript="true" />
                  </b-col>
                </b-row>
                <div class="error" v-if="isShowMsgCaptcha">Por favor complete el captcha.</div>
                <br>
                <b-row>
                  <b-col cols="12" md="6" lg="5">
                    <b-button block size="lg" variant="success" @click="validarFormulario()">
                      <b-spinner v-if="isCalculando"></b-spinner>
                      <strong v-if="isCalculando"> Consultando . . .</strong>
                      <strong v-if="!isCalculando"> Continuar</strong>
                    </b-button>
                    <br>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
              

            <b-row v-if="estado!=null" >
              <b-col cols="12" class="card-form-primary mb-4" >
                <b-row class="mt-3 mb-3" align="center">
                  <b-col cols="12"><h6 style="color:gray;">Placa</h6></b-col>
                  <b-col cols="12"><h2>{{estado.placa}}</h2></b-col>
                  <b-col cols="12"><h3>{{estado.vigente?"VIGENTE":"--"}}</h3></b-col>
                  <b-col cols="12" v-if="estado.minutos!=null && !estado.minutos.includes('-')"><h4>{{estado.minutos}} minutos</h4></b-col>
                  <b-col cols="12"><h5>{{estado.fin}}</h5></b-col>
                  <b-col cols="12"><h6>{{estado.msg}}</h6></b-col>
                </b-row>
                
              </b-col>
              <b-col cols="12" class="card-form-purple " >
                <b-tabs justified class="mt-3 mb-3" v-model="tabSel">
                  <b-tab active>
                    <template #title>
                      <h5 v-if="tabSel==0">Pagar Parquímetro</h5>
                      <h5 v-if="tabSel!=0" style="color:silver;">Pagar Parquímetro</h5>
                    </template>
                    <b-row>
                      
                      <b-col cols="12" class="mt-2">
                        <h6>Seleccione el tiempo a pagar</h6>
                        <b-form-select :state="tiemposel!=null && tiemposel!=''" v-model="tiemposel" :options="opstiempo" @change="modificaMontoP"></b-form-select>
                      </b-col>
                      <b-col class="mt-3">
                        <b-row>
                          <b-col><b>Monto:</b></b-col>
                          <b-col><b>$ {{montomin}}.00</b></b-col>
                        </b-row>
                        <b-row>
                          <b-col><b>Saldo:</b></b-col>
                          <b-col><b>$ {{estado.saldo}}.00</b></b-col>
                        </b-row>

                        <b-row>
                          <b-col><b>Por pagar:</b></b-col>
                          <b-col><b>$ {{porpagar}}.00</b></b-col>
                        </b-row>

                        <b-row class="mt-3">
                          <b-col>
                            <b-button variant="success" pill block size="lg" @click="generarPagoEnLinea(tiemposel)">Pagar <b-icon icon="credit-card-fill"/></b-button>
                          </b-col>
                        </b-row>
                      </b-col>

                    </b-row>
                  </b-tab>
                  <b-tab >
                    <template #title>
                      <h5 v-if="tabSel==1">Comprar Saldo</h5>
                      <h5 v-if="tabSel!=1" style="color:silver;">Comprar Saldo</h5>
                    </template>
                    
                    <b-row>
                      <b-col>

                        <b-row class="mt-3">
                            <b-col><b>Saldo Actual:</b></b-col>
                            <b-col><b>$ {{estado.saldo}}</b></b-col>
                        </b-row>
                        <b-row class="mt-2 mb-4">
                            <b-col><b>Saldo a comprar:</b></b-col>
                            <b-col><b-form-input type="number" v-model="saldocompra"></b-form-input></b-col>
                        </b-row>
                        

                        <b-row>
                          <b-col>
                            <b-button variant="success" pill block size="lg" @click="generarPagoEnLinea(saldocompra)">Pagar <b-icon icon="credit-card-fill"/></b-button>
                          </b-col>
                        </b-row>

                      </b-col>
                    </b-row>
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>


            <div v-if="estado!=null" class="mt-5">
              <b-row align="center"><b-col style="margin-bottom:15px;"><b-button variant="danger" size="lg" pill @click="cleanResults"><b-icon icon="arrow-left-circle"/> Regresar</b-button></b-col></b-row>
            </div>

           
            
            <b-row align-h="center">
              <b-col cols="12" lg="12">
                <b-alert variant="danger" dismissible @dismissed="cleanMsgError" :show="msgErrorGenLinea != ''">
                  {{msgErrorGenLinea}}
                </b-alert>
              </b-col>
            </b-row>
            
          </b-col>
        </b-row>


      </b-col>
    </b-row>
       
    
    <!--------------------------------------------------------------------- MODALS -------------------------------------------------------------------->

    <b-modal @shown="focusModalPago"  scrollable title="Pago de parquímetro" v-model="isShowModalInfoPagoEnLinea" @hide="borrarDatosPago()" hide-footer>
      <b-row align="center" align-h="center" v-if="urlForPayment==null || urlForPayment==''">
        <b-col col1s="11">
          <b-icon style="color:#DAD7FF" icon="envelope" font-scale="6"/>
        </b-col>
        <b-col cols="11" >
          <h6>Ingresa tus datos</h6>
          <br>
          <b-form-group >
            <h6>Nombre</h6>
            <b-form-input  ref="focusCorreoPago" style="text-align: center;" type="text" v-model.trim="nombrePago"></b-form-input>
            <br>
            <h6>Apellido paterno</h6>
            <b-form-input  style="text-align: center;" type="text" v-model.trim="apellidoPago"></b-form-input>
            <br>
            <h6>Correo electrónico</h6>
            <b-form-input  style="text-align: center;" type="email" v-model.trim="correoParaPago"></b-form-input>
            <br>
            <h6>Teléfono</h6>
            <b-form-input  style="text-align: center;" type="number" v-model.trim="telefonoPago"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-button @click="altaCorreo()" 
          :disabled="correoParaPago==null || correoParaPago=='' || !correoParaPago.includes('@')" size="lg" pill variant="success">Continuar <b-icon icon="arrow-right-circle"/>
          </b-button><br><br><br>
        </b-col>
        <b-col class="mb-3" cols="12">Al dar click en continuar, aceptas nuestro <a :href="servicios.urlTerminos" target="_blank">Aviso de Privacidad, Términos y Condiciones.</a>.</b-col>
      </b-row>




    </b-modal>

    
  </b-container>
</template>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { minLength, alphaNum, maxLength, required} from 'vuelidate/lib/validators';
import { mapState} from 'vuex';
import { server, getPostConfig, handledError, getGetConfig } from '@/axios-tools';
import axios from 'axios';
import { genPdfLinea } from '@/vue-tools';
import VueRecaptcha from 'vue-recaptcha';
import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)


export default {
  computed:{
    ...mapState({
      parcialidades: state => state.contribuyente.parcialidades,
      totalLiquidacion: state => state.contribuyente.totalLiquidacion,
      resumenLiquidacion: state => state.contribuyente.resumenLiquidacion,
      datosPago: state => state.contribuyente.datosPago,
      isCalculando: state => state.contribuyente.isCalculando,
      isGenerando: state => state.contribuyente.isGenerando,
      idxUltParcialidad: state => state.contribuyente.idxUltParcialidad,
      msgErrorContribuyente: state => state.contribuyente.msgErrorContribuyente,
      msgErrorGenLinea: state => state.contribuyente.msgErrorGenLinea,
      terminosServicio: state => state.contribuyente.catalogContribuyente.terminosServicio,
      thems: state => state.contribuyente.catalogContribuyente.thems,
      test: state => state.contribuyente.test
    }),
    them(){
      var them;
      if(this.$route.params.municipio == this.thems.teotihuacan){
        them = this.thems.teotihuacan;
      }else if(this.$route.params.municipio == this.thems.demo){
        them =  this.thems.demo;
      }
      return them;
    },
  },
  data(){
    return{

      tabSel:0,

      placa:"",
      correoParaPago:null,
      nombrePago:null,
      apellidoPago:null,
      telefonoPago:null,

      estado:null,
      tiemposel:"",
      opstiempo:[
        "30 min",
        "60 min",
        "90 min",
        "120 min",
        "150 min",
        "180 min",
        "210 min",
        "240 min",
        "270 min",
        "300 min",
        "330 min",
        "360 min",
        "390 min",
        "420 min",
        "450 min",
        "480 min",
        "510 min",
        "540 min",

      ],
      montomin:0,
      porpagar:0,
      saldocompra:0,

      servicios:{
        facturacion: false,
        pagoAgua: false,
        pagoAnuncios: false,
        pagoBebidas: false,
        pagoComercio: false,
        pagoEnLinea: false,
        pagoEstacionamiento: false,
        pagoJuegos: false,
        pagoPadronMensual: false,
        pagoPanteon: false,
        pagoPredial: false,
        urlTerminos: false,
      },
      isShowCollapseMensual:false,
      isShowCollapsePredial:true,
      
      clavePost:null,
      claveCatastral:null,
      cuentaAgua:null,
      isValidForm:null,
      tipoPadron:null,
      tipoLiq:"1",
      contenidoLineaCaptura:null,
      isShowModalLineaCaptura:false,
      
      isShowModalInfoPagoEnLinea:false,
      pdfGenerated: null, /*Almacena el url con blob del pdf para mostrar en el iframe*/
      captchaPredial:null,
      
      isShowMsgCaptcha:false,
      collapseColor: "secondary",
      
      urlForPayment:'',

      mpio : this.$route.params.municipio,

    

    }
  },
  components: {
    VueRecaptcha,
    Loading
  },
  created: function () {
      this.getServices();

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      let idPlaca=urlParams.get('id');
      if(idPlaca!=null && idPlaca!=''){
        
          this.placa = idPlaca;
          axios(
                        
                        getPostConfig(server.consultaparquimetro, {placa:this.placa}, null, {alias:this.mpio})
                        
                    )
                    .then(res => {
                        if(res.data.correo==null || res.data.correo==''){
                          this.isShowModalInfoPagoEnLinea=true;
                        }else{
                          this.estado = res.data;
                        }
                    }).catch(e => {
                        alert(e);
                        
                        this.isConsultando = false;
                        
                    });
          
        
      
      }

    },
  methods:{
    getServices(){
      axios(
        getGetConfig(server.servicios, null, null, {codeClient:this.$route.params.municipio})
      )
      .then(res => {
        this.servicios = res.data;
      }).catch(err => {
        handledError(err, server.servicios, this.$router, this.$store);
      });
    },
    countDownChanged(isShowMsgErrorCodigo) {
      this.isShowMsgErrorCodigo = isShowMsgErrorCodigo;
    },
    showModalAceptarTerminos(){
      this.isShowModalAceptarTerminos=true;
    },
    
    cleanMsgError(){
      /* Se manda cadena vacia a MsgErrorContribuyente en el store, ya que el <b-alert> para mostrar errores solo se muestra si este es diferente de cadena vacia */
      this.$store.commit("updateMsgErrorContribuyente", '');
      this.$store.commit("updateMsgErrorGenLinea", '');
    },
    
    captchaPredialFilled(token){
      this.captchaPredial = token;
      this.isShowMsgCaptcha = false;
    },
    captchaPredialExpired(){
      this.captchaPredial = null;
    },
    
    cleanResults(){
      /* Limpia toda la información de la liquidación en el store, cuando se manda una nueva petición */
      this.$store.commit("updateDatosPagoContribuyente", null);
      this.$store.commit("updateParcialidadesContribuyente", null);
      this.$store.commit("updateTotalLiquidacionContribuyente", null);
      this.$store.commit("updateMsgErrorContribuyente", '');
      this.isShowMsgCaptcha = false;
      
      this.placa="";
      this.correoParaPago=null;
      this.nombrePago=null;
      this.apellidoPago=null;
      this.telefonoPago=null;
      this.estado=null;
      
    },
    
    cleanCaptchas(){
      /* Una vez que se ha enviado una petición 'consultaadeudo', es necesario limpiar los token(captcha), ya que solo son validos para una petición */
      this.captchaPredial = null;
      
      /* Despues de limpiar los token, para que un usuario pueda solicitar un nuevo token se resetean los captcha */
      if(this.$refs.recaptchaPredial != null){this.$refs.recaptchaPredial.reset();}
      
    },
    modificaMontoP(){
      this.montomin = parseInt(this.tiemposel.replace(' min', ''))
      this.montomin =  parseInt(Math.round(this.montomin *.13333333))

      if(this.estado.saldo >= this.montomin){
        this.porpagar = 0;
      }else{
        this.porpagar = this.montomin - this.estado.saldo;
      }

    },
    validarFormulario(){
     
        if(this.captchaPredial != null){
          if(!this.$v.placa.$invalid && !this.isCalculando){
            axios(
                        
                        getPostConfig(server.consultaparquimetro, {placa:this.placa}, null, {alias:this.mpio})
                        
                    )
                    .then(res => {
                        if(res.data.correo==null || res.data.correo==''){
                          this.isShowModalInfoPagoEnLinea=true;
                        }else{
                          this.estado = res.data;
                        }
                    }).catch(e => {
                        alert(e);
                        
                        this.isConsultando = false;
                        
                    });
          }
        }else{
          this.isShowMsgCaptcha = true;
        }
      
    },
    altaCorreo(){
     
        axios(
                    
                    getPostConfig(server.correoparquimetro, {placa:this.placa, correo:this.correoParaPago, nombre:this.nombrePago, apellido:this.apellidoPago, numero:this.telefonoPago}, null, {alias:this.mpio})
                    
                )
                .then(res => {
                    this.estado = res.data;
                    this.isShowModalInfoPagoEnLinea = false;
                }).catch(e => {
                    alert(e);
                    
                    this.isConsultando = false;
                    
                });
      
    },
    generarPagoEnLinea(concepto){
      if(!this.isCalculando && !this.isGenerando ){

        if((this.tiemposel==null || this.tiemposel=='') && this.tabSel==0){
          alert('Seleccione el tiempo a pagar')

        }else{
          this.$store.commit("updateIsGenerandoContribuyente", true);
          this.cleanMsgError();
        
            axios(
                getPostConfig(server.generacionpagoenlineaparq, {placa:this.estado.placa, msg:concepto+''}, null, {alias:this.$route.params.municipio})
            ).then(res => {
                //this.urlForPayment = res.data; //para mostrarla embebida
                window.open(res.data, '_self') //_blank para redireccionar a una nueva pagina
                this.$store.commit("updateIsGenerandoContribuyente", false);
                this.cleanResults();
                this.isShowModalInfoPagoEnLinea=false;
            }).catch(err => {
                this.$store.commit("updateIsGenerandoContribuyente", false);
                handledError(err, server.generaPagoEnLinea, this.$router, this.$store);
            })
        }
        
       
      }
    },
    borrarDatosPago(){
      this.correoParaPago=null;
      if( this.urlForPayment!=null && this.urlForPayment!=''){//solo si ya se genero una orden
        this.contenidoLineaCaptura=null;
        this.urlForPayment=null;
        this.cleanResults();
      }
    },
    abrirModalPago(){
      window.scroll(0, 0);
      this.correoParaPago=null;
      this.urlForPayment=null;
      this.isShowModalInfoPagoEnLinea=true;
    },
    generarLineaCaptura(isSoloImprimir){
      if(!this.isCalculando && !this.isGenerando ){
          this.$store.commit("updateIsGenerandoContribuyente", true);
          if(isSoloImprimir){
              this.$store.commit("updateIsGenerandoContribuyente", false);
              this.generarPdf(isSoloImprimir);
          }else{
            this.cleanMsgError();
            axios(
                getPostConfig(server.generarLineaCaptura, null, null, {tipoPadron:this.tipoPadron, claveContribuyente:this.clavePost, idxUltParcialidad:this.idxUltParcialidad, codeClient:this.$route.params.municipio, tipoLiq:this.tipoLiq})
            ).then(res => {
                this.pdfGenerated = res.data;
                //this.generarPdf(isSoloImprimir);
                this.isShowModalLineaCaptura = true;
                this.$store.commit("updateIsGenerandoContribuyente", false);
            }).catch(err => {
                this.$store.commit("updateIsGenerandoContribuyente", false);
                handledError(err, server.generarLineaCaptura, this.$router, this.$store);
            })
          }   
      }
    },
    // generarPdf(isSoloImprimir){
    //   if(isSoloImprimir){
    //     this.soloImprimir();
    //   }else{
    //     var detalle = this.tipoLiq=='2'?'PAGO DE COLEGIATURA ...' :this.contenidoLineaCaptura.detalle; //eSTO ES TEMPORAL
    //     var totalLiquidacion = this.contenidoLineaCaptura.total;
    //     var fecha = this.contenidoLineaCaptura.fecha;
    //     var fechav = this.contenidoLineaCaptura.fechav;
    //     var formasPago = [this.contenidoLineaCaptura.formasPago.length];
    //     var folio = this.contenidoLineaCaptura.folio;
    //     var logoMpio2 = this.contenidoLineaCaptura.logoMpio2;
    //     var qrCodi = this.contenidoLineaCaptura.qrCodi;
    //     for (var idxFormasPago in this.contenidoLineaCaptura.formasPago){
    //       formasPago[idxFormasPago] = [this.contenidoLineaCaptura.formasPago[idxFormasPago].nombre + " - " + this.contenidoLineaCaptura.formasPago[idxFormasPago].ref];
    //     }
    //     var parcialidades = [this.contenidoLineaCaptura.parcialidades.length];
    //     for (var index in this.contenidoLineaCaptura.parcialidades){
    //       if(this.contenidoLineaCaptura.parcialidades[index].pagar){
    //         parcialidades[index] = [
    //             this.contenidoLineaCaptura.parcialidades[index].periodo, 
    //             this.contenidoLineaCaptura.parcialidades[index].importe, 
    //             this.contenidoLineaCaptura.parcialidades[index].recargo, 
    //             this.contenidoLineaCaptura.parcialidades[index].multa, 
    //             this.contenidoLineaCaptura.parcialidades[index].pae, 
    //             this.contenidoLineaCaptura.parcialidades[index].subsidios, 
    //             this.contenidoLineaCaptura.parcialidades[index].total ]
    //       }
    //     }
    //     this.pdfGenerated = genPdfLinea(detalle, parcialidades, totalLiquidacion, formasPago, true, fecha, fechav, folio, logoMpio2, qrCodi, this.$route.params.municipio);
    //   }
    //   this.isShowModalLineaCaptura = true;
    //   this.cleanResults();
    // },
    soloImprimir(){
      var parcialidadesCobrables = [this.idxUltParcialidad+1];
        for (var index in this.parcialidades){
            if(parseInt(index) <= this.idxUltParcialidad){
              parcialidadesCobrables[index] = [ 
                  this.parcialidades[index].periodo, 
                  this.parcialidades[index].importe, 
                  this.parcialidades[index].recargo, 
                  this.parcialidades[index].multa, 
                  this.parcialidades[index].pae, 
                  this.parcialidades[index].subsidios, 
                  this.parcialidades[index].total ]
            }
        }
        this.pdfGenerated = genPdfLinea(this.datosPago[0].detalle, parcialidadesCobrables, this.totalLiquidacion, null, false, null, null, null, null);
    },
    printOrdenPago(){
      document.getElementById('embed1').contentWindow.print();
    },
    focusModalPago(){
      this.$refs.focusCorreoPago.focus();
    },  
  },
  validations:{
    cuentaMensual:{
            required,
            alphaNum,
            minLength: minLength(16),
            maxLength: maxLength(16)
          },
    cuentaAgua:{
            required,
            minLength: minLength(1),
            maxLength: maxLength(20)
    },
    placa:{
            required,
            minLength: minLength(5),
            maxLength: maxLength(16)
          },
    
    
    /*email:{
            required,
            minLength: minLength(5),
            maxLength: maxLength(200)
    },*/
    emailPago:{
            required,
            minLength: minLength(5),
            maxLength: maxLength(200)
    }
  }
}
</script>
<style>
.row-to-img-orden{
  margin-left:40px;
}
.button-reenviar{
  margin-top: 5px;
}
.dropdown{
  margin-bottom: 5px;
}
.input-folio{
  margin-top:10px;
}
.input-serie{
  margin-top:10px;
}
.b-icon-info-recibo{
  margin-right:20px;
}
.margin-radio-recibo{
  margin-right:5px;
}
.margin-radio-linea{
  margin-right:5px;
}
.link-pdf{
  margin-left:20px;
}
.margin{
  margin: 5px auto;
}
div.error{
  color: red;
}
div.success{
  color: green;
  margin-bottom: 10px;
}

/*------------------------------------------------------------------------------- THEMS -------------------------------------------------------------------------- */
.teotihuacan:hover{
   background-color:#A03455;
   border-color:#A03455;
}
.teotihuacan{
   background-color:#9D2449; 
   border-color:#9D2449;
}
.demo:hover{
  background-color:#5F58B1;
   border-color:#5F58B1;
}
.demo{
  background-color:#312991; 
   border-color:#312991;
}
</style>